import { combineReducers } from 'redux';

import hasAnsweredSurvey from './hasAnsweredSurvey';
import hasCuratedTickets from './hasCuratedTickets';
import hasMadeIntroduction from './hasMadeIntroduction';
import isFetching from './isFetching';
import isViewingSurvey from './isViewingSurvey';
import status from './status';
import survey from './survey';

const tara = combineReducers({
  hasAnsweredSurvey,
  hasCuratedTickets,
  hasMadeIntroduction,
  isFetching,
  isViewingSurvey,
  status,
  survey,
});

export default tara;



// WEBPACK FOOTER //
// ./src/reducers/tara/index.js